import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Card, Title, Group, Text, Modal } from "@mantine/core";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useDisclosure } from "@mantine/hooks";
import { Sparkline } from "@mantine/charts";
import { PlusIcon } from "@heroicons/react/24/outline";

const TradingInsight = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const [isListVisible, setIsListVisible] = useState(false);
  const [isListOne, setIsListOne] = useState(false);
  const [isListTwo, setIsListTwo] = useState(false);
  const [isListThree, setIsListThree] = useState(false);
  const [isListFour, setIsListFour] = useState(false);
  
  const data = [
    { date: "2025-05-22", BTC: 100000, Asia: -1, Europe: -2, America: -3 },
    { date: "2025-06-03", BTC: 105000, Asia: 2, Europe: -1, America: -4 },
    { date: "2025-06-15", BTC: 110000, Asia: 3, Europe: -2, America: -5 },
    { date: "2025-06-27", BTC: 115000, Asia: 5, Europe: -1, America: -3 },
    { date: "2025-07-09", BTC: 120000, Asia: 9, Europe: 0, America: -2 },
    { date: "2025-07-21", BTC: 118000, Asia: 7, Europe: -2, America: -4 },
    { date: "2025-08-02", BTC: 124000, Asia: 12, Europe: 1, America: -1 },
    { date: "2025-08-14", BTC: 115000, Asia: 8, Europe: -3, America: -5 },
    { date: "2025-06-27", BTC: 115000, Asia: 5, Europe: -1, America: -3 },
    { date: "2025-07-09", BTC: 120000, Asia: 9, Europe: 0, America: -2 },
    { date: "2025-07-21", BTC: 118000, Asia: 7, Europe: -2, America: -4 },
      { date: "2025-06-03", BTC: 105000, Asia: 2, Europe: -1, America: -4 },
    { date: "2025-06-15", BTC: 110000, Asia: 3, Europe: -2, America: -5 },
  ];

  const toggleListVisibility = () => {
      setIsListVisible(!isListVisible);
  }
    const togglebuttonone = () => {
      setIsListOne(!isListOne);
  }
    const togglebuttontwo = () => {
      setIsListTwo(!isListTwo);
  }
    const togglebuttonthree = () => {
      setIsListThree(!isListThree);
  }
    const togglebuttonfour = () => {
      setIsListFour(!isListFour);
  }
  return (
    <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
      <Header />
      <div className="max-w-7xl mx-auto lg:flex block px-2">
        <h2 className="text-xl font-bold mr-4">Trading Insight</h2>
        <p className="text-sm text-gray-500 mt-2">
          Visually intuitive, chart-based analysis of market movements, making
          it easier to identify trends and take advantage of opportunities at a
          glance.
        </p>
      </div>
      <div className="lg:flex max-w-7xl mx-auto my-3 border-t">
        <aside className="lg:w-64 w-full border-r p-4">
          <div className="flex items-center mb-4 border rounded px-2 py-1">
            <FaSearch className="text-gray-500" />
            <input
              type="text"
              placeholder="Search"
              className="ml-2 w-full outline-none text-sm"
            />
          </div>

          <div>
            <div className="flex space-x-2">
              <h2 className="text-md font-bold mb-2">
              Exchange - Trading Data
            </h2>
              <PlusIcon className="w-5 h-5 cursor-pointer border rounded-xl" onClick={toggleListVisibility}/>
            </div>
           { isListVisible && (
             <ul className="text-sm space-y-2">
              <li>
                Price Index - Asia/Europe/America
              </li>
              <li>Trade Volume by Region</li>
              <li>Price Fluctuation by Region</li>
              <li>Fund flow</li>
              <li>Fund flow - buy (large)</li>
              <li>Fund flow - buy (medium)</li>
              <li>Fund flow - buy (small)</li>
              <li>Fund flow - sell (large)</li>
              <li>Fund flow - sell (medium)</li>
              <li>Fund flow - sell (small)</li>
              <li>Fund flow - net inflow</li>
              <li>Margin Debt Growth (C)</li>
              <li>Margin Debt Growth (U)</li>
              <li>Margin Long-short Positions Ratio (C)</li>
              <li>Margin Long-short Positions Ratio (U)</li>
              <li>Isolated Margin Borrow Amount Ratio</li>
            </ul>
           )}
          </div>

          <div className="mt-4 space-y-2">
            <div className="flex space-x-2">
              <h2 className="text-md font-bold mb-2">Exchange - Futures Data </h2>
              <PlusIcon className="w-5 h-5 cursor-pointer rounded-xl border" onClick={togglebuttonone}/>
            </div>
            { isListOne && (
              <ul className="text-sm space-y-2">
                <li>Open Interest</li>
                <li>Top Trader Long/Short Ratio (Accounts)</li>
                <li>Long/Short Ratio</li>
                <li>Taker Buy/Sell Volume</li>
                <li>Basis</li>
                <li>Funding rate</li>
              </ul>
            )}
            <div className="flex space-x-2">
              <h2 className="text-md font-bold mb-2">Tillionx Square Data </h2>
              <PlusIcon className="w-5 h-5 border rounded-xl cursor-pointer"  onClick={togglebuttontwo}/>
            </div>
            { isListTwo && (
              <ul className="text-sm space-y-2">
                <li>Popularity Index (Posts)</li>
                <li>Popularity Index (Clicks)</li>
                <li>Fear and Greed Index</li>            
              </ul>
            )}
            <div className="flex space-x-2">
              <h2 className="text-md font-bold mb-2">Kline Pattern </h2>
              <PlusIcon className="w-5 h-5 border rounded-xl cursor-pointer"  onClick={togglebuttonthree}/>
            </div>
            { isListThree && (
              <ul className="text-sm space-y-2">
                <li>Hammer</li>
                <li>Hikkake Pattern</li>
                <li>Separating Lines</li>
                <li>Long Legged Doji</li>
                <li>Engulfing Pattern</li>
                <li>Matching Low</li>
                <li>Closing Marubozu</li>
                <li>Belt-hold</li>
                <li>Three Outside Up/Down</li>
                <li>Doji</li>
                <li>Short Line Candle</li>
                <li>Gravestone Doji</li>
                <li>Marubozu</li>
                <li>Long Line Candle</li>
                <li>Hanging Man</li>
                <li>High-Wave Candle</li>
                <li>Advance Block</li>
                <li>Morning Star</li>
                <li>Rickshaw Man</li>
                
              </ul>
            )}
            <div className="flex space-x-2">
              <h2 className="text-md font-bold mb-2">ETF </h2>
              <PlusIcon className="w-5 h-5 border rounded-xl cursor-pointer"  onClick={togglebuttonfour}/>
            </div>
            { isListFour && (
              <ul className="text-sm space-y-2">
                <li>ETF net inflow</li>
                
              </ul>
            )}
          </div>
        </aside>

        <main className="flex-1 lg:p-6 p-2">
          <div className="lg:flex justify-between items-center mb-6">
            <h1 className="text-xl font-bold mb-3 lg:mb-0">
              BTC/USDT{" "}
              <span className="text-red-500 text-lg">11312.46 -0.65%</span>
            </h1>
            <div className="flex items-center space-x-2">
              {/* <button className="px-2 py-1 border rounded text-sm">1d</button><br></br> */}
              <input
                type="date"
                className="border lg:px-2 px-1 py-1 rounded lg:text-sm text-xs bg-transparent"
                defaultValue="2025-05-23"
              />
              <span>→</span>
              <input
                type="date"
                className="border lg:px-2 px-1 py-1 rounded lg:text-sm text-xs bg-transparent"
                defaultValue="2025-08-21"
              />
            </div>
          </div>

          <div className="w-full bg-transparent">
            <Card shadow="lg" padding="lg" radius="lg" withBorder className="bg-transparent">
              <Group position="apart">
                <Title className="pb-12" order={4}>
                  Price Index - Asia/Europe/America
                </Title>
                <Text size="sm" color="dimmed">
                  BTC/USDT
                </Text>
              </Group>

              <ResponsiveContainer
                width="100%"
                height={350}
                className="outline-none bg-transparent border-primary"
              >
                <LineChart
                  data={data}
                  margin={{ top: 10, right: 0, left: -20, bottom: 0 }}
                  className="bg-transparent"
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#ddd" />
                  <XAxis dataKey="date" />
                  <YAxis yAxisId="left" orientation="left" />
                  <YAxis yAxisId="right" orientation="right" />
                  <Tooltip />
                  <Legend />

                  <Line
                    yAxisId="right"
                    type="monotone"
                    dataKey="BTC"
                    stroke="#FFD700"
                    strokeWidth={2}
                    dot={false}
                  />

                  <Line
                    yAxisId="left"
                    type="monotone"
                    dataKey="Asia"
                    stroke="#1E90FF"
                    strokeWidth={2}
                    dot={false}
                  />

                  <Line
                    yAxisId="left"
                    type="monotone"
                    dataKey="Europe"
                    stroke="#FF4500"
                    strokeWidth={2}
                    dot={false}
                  />

                  <Line
                    yAxisId="left"
                    type="monotone"
                    dataKey="America"
                    stroke="#9370DB"
                    strokeWidth={2}
                    dot={false}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Card>
          </div>

          <div className="mt-4">
            <h2 className="font-semibold">Description</h2>
            <p className="text-sm text-gray-600">
              The proportion of net long and net short positions to total open positions of the top 20% users with the highest margin balance.
              Long Position % = Long positions of top traders / Total open positions of top traders
              Short Position % = Short positions of top traders / Total open positions of top traders
              Long/Short Ratio (Positions) = Long Position % / Short Position %
            </p>
          </div>
        </main>

        <aside className="w-80 border-l p-6">
          <h2 className="text-lg font-semibold mb-2">Fear & Greed Index</h2>
          <div className="border rounded-lg p-4 mb-6 text-center">
            <div className="text-2xl font-bold">50</div>
            <p className="">Neutral</p>
            <div className="flex justify-between text-xs mt-3">
              <span>Yesterday: 45</span>
              <span>Last Week: 68</span>
            </div>
          </div>

          <h2 className="text-lg font-semibold mb-2">Popular</h2>
          <ul className="space-y-3 text-sm">
            {[
              { rank: 1, name: "GAS", change: "+4.11%" },
              { rank: 2, name: "BB", change: "+16.73%" },
              { rank: 3, name: "PHA", change: "+7.42%" },
              { rank: 4, name: "SAGA", change: "+2.18%" },
              { rank: 5, name: "LA", change: "+2.32%" },
              { rank: 6, name: "QTUM", change: "+12.00%" },
              { rank: 7, name: "PENDLE", change: "+4.96%" },
              { rank: 8, name: "1000CAT", change: "+3.37%" },
              { rank: 9, name: "NOT", change: "+0.38%" },
            ].map((coin) => (
              <li
                key={coin.rank}
                className="flex justify-between items-center border-b pb-2"
                onClick={open}
              >
                <span className="font-medium">
                  {coin.rank}. {coin.name}
                </span>
                <span className="text-green-600">{coin.change}</span>
              </li>
            ))}
            <Modal
              className="rounded-2xl"
              opened={opened}
              onClose={close}
              centered
              title={"Trending Coin Detail"}

            >
              <div className="mb-4">
                <div className="flex items-center space-x-2 mb-1">
                  <img
                    src="https://via.placeholder.com/24" // Placeholder for IMX logo
                    alt="IMX logo"
                    className="h-6 w-6 rounded-full"
                  />
                  <span className="text-2xl font-bold text-gray-900">IMX</span>
                </div>
                <div className="flex items-baseline space-x-2">
                  <span className="text-3xl font-bold text-gray-900">
                    0.534
                  </span>
                  <span className="text-red-500 text-sm font-semibold">
                    -3.62%
                  </span>
                  <span className="text-gray-500 text-sm">1d change</span>
                </div>
                <div className="flex items-center space-x-2 mt-2 text-yellow-500">
                  <span className="text-xl">🏆</span>
                  <span className="font-semibold">Popular #14</span>
                </div>
              </div>
              <div className="md:flex md:space-x-4 space-y-2 md:space-y-0 mb-4">
                <div className="flex items-center space-x-1 border rounded px-2 py-1 bg-slate-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                  <span className="text-sm">Search +0</span>
                </div>
                <div className="flex items-center space-x-1 border rounded px-2 py-1 bg-slate-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11.049 2.927c.3-.921 1.638-.921 1.938 0l2.054 6.331a1 1 0 00.95.69h6.643c.968 0 1.372 1.258.591 1.815l-5.378 3.91a1 1 0 00-.364 1.118l2.054 6.331c.3.921-.755 1.688-1.536 1.118l-5.378-3.91a1 1 0 00-1.17 0l-5.378 3.91c-.78.57-1.835-.197-1.536-1.118l2.054-6.331a1 1 0 00-.364-1.118L2.99 11.763c-.78-.557-.376-1.815.592-1.815h6.643a1 1 0 00.95-.69L11.05 2.927z"
                    />
                  </svg>
                  <span className="text-sm">Favorite +0</span>
                </div>
                <div className="flex items-center space-x-1 border rounded px-2 py-1 bg-slate-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                    />
                  </svg>
                  <span className="text-sm">Mention +54</span>
                </div>
              </div>
              <Sparkline
                w={"100%"}
                h={260}
                data={[10, 20, 40, 20, 40, 10, 50, 30, 40, 50, 30, 50, 70, 20, 70]}
                curveType="linear"
                color="green"
                fillOpacity={0.5}
                strokeWidth={2}
              />
              <div className="mb-4 mt-6">
                <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                  Market Sentiment
                  <span className="text-sm ml-1 text-gray-400">ⓘ</span>
                </h3>
                <div className="flex items-center mt-2">
                  <div className="w-[39.2%] h-2 bg-green-500 rounded-l-full"></div>
                  <div className="w-[60.8%] h-2 bg-red-500 rounded-r-full"></div>
                </div>
                <div className="flex justify-between text-sm mt-1">
                  <span className="text-green-500 font-semibold">
                    +39.20% Buy
                  </span>
                  <span className="text-red-500 font-semibold">
                    Sell +60.80%
                  </span>
                </div>
              </div>
              <h4 className="text-xl font-bold mr-4">Market Sentiment</h4>
              <p className="text-sm text-gray-500 mt-2">
                OVERTAKE, a peer-to-peer game asset trading platform based on
                the Sui Network, announced it has completed a $7 million
                strategic funding round with participation from Sui, ItemMania,
                ItemBay, JB Investment, Green Whale Ventures, and Immutable.
              </p>
            </Modal>
          </ul>
        </aside>
      </div>
      
      <Footer />
    </div>
  );
};

export default TradingInsight;
